(function () {
  function money(cents) {
    const negative = cents < 0;
    const abs = Math.abs(Math.round(cents));
    const pounds = String(Math.floor(abs / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const pence = String(abs % 100).padStart(2, '0');
    return (negative ? '-' : '') + '£' + pounds + '.' + pence;
  }

  function pounds(cents) {
    const value = cents / 100;
    if (Number.isInteger(value)) return '£' + String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return money(cents);
  }

  function centsOf(node, name) {
    return parseInt(node.getAttribute(name) || '0', 10) || 0;
  }

  function quantityOf(root) {
    const input = root.querySelector('[name="quantity"]');
    const value = parseInt(input && input.value, 10);
    return value > 0 ? value : 1;
  }

  function variantId(root) {
    const field = root.querySelector('[data-cf-variant]');
    return field ? field.value : '';
  }

  function checked(root, group) {
    return root.querySelector('[data-cf-choice][data-group="' + group + '"]:checked');
  }

  const propertyNames = {
    sim: 'properties[Connectivity (SIM)]',
    monitoring: 'properties[WebAlarm Monitoring]',
  };

  function sync(root) {
    ['sim', 'monitoring'].forEach(function (group) {
      const choice = checked(root, group);
      const summary = root.querySelector('[data-cf-group="' + group + '"] [data-cf-summary]');
      const property = root.querySelector('[data-cf-property="' + group + '"]');
      if (choice && summary) summary.textContent = choice.dataset.summary || choice.dataset.label || '';
      if (!property) return;
      if (!property.dataset.cfField) {
        property.dataset.cfField =
          property.getAttribute('data-cf-property-name') || property.getAttribute('name') || propertyNames[group];
      }
      const value = choice && choice.dataset.property ? choice.dataset.property : '';
      if (value) {
        property.disabled = false;
        property.name = property.dataset.cfField;
        property.value = value;
      } else {
        property.value = '';
        property.disabled = true;
        property.removeAttribute('name');
      }
    });
    const added = root.querySelectorAll('[data-cf-addon-add][data-added="true"]').length;
    const addonSummary = root.querySelector('[data-cf-group="addons"] [data-cf-summary]');
    if (addonSummary) addonSummary.textContent = added + ' added';
    const status = root.querySelector('[data-cf-config-status]');
    if (status) {
      const parts = [];
      const sim = root.querySelector('[data-cf-group="sim"] [data-cf-summary]');
      const monitoring = root.querySelector('[data-cf-group="monitoring"] [data-cf-summary]');
      if (sim && sim.textContent.trim()) parts.push(sim.textContent.trim());
      if (monitoring && monitoring.textContent.trim()) {
        const text = monitoring.textContent.trim();
        parts.push(/^not selected$/i.test(text) ? 'WebAlarm not selected' : text);
      }
      if (addonSummary) {
        parts.push(added === 1 ? '1 add-on' : added + ' add-ons');
      }
      status.textContent = parts.join(' · ');
    }
  }

  function line(parent, left, right) {
    const row = document.createElement('div');
    const label = document.createElement('span');
    label.textContent = left;
    row.appendChild(label);
    if (right) {
      const amount = document.createElement('b');
      amount.textContent = right;
      row.appendChild(amount);
    }
    parent.appendChild(row);
  }

  function refresh(root) {
    if (!root || !root.querySelector) return;
    sync(root);
    const panel = root.querySelector('[data-cf-subtotal]');
    if (!panel) return;
    const price = root.querySelector('[data-cf-price]');
    let unit = parseInt(price && price.dataset.cfPriceCents, 10) || 0;
    const qty = quantityOf(root);
    const recurring = [];

    root.querySelectorAll('[data-cf-choice]:checked').forEach(function (input) {
      const cadence = input.dataset.cadence;
      const label = input.dataset.label || '';
      const upfront = input.dataset.upfront === 'true' ? upfrontCents(input) : 0;
      if (upfront) {
        unit += upfront;
      } else if (cadence === 'trial') {
        recurring.push({
          kind: 'trial',
          monthly: centsOf(input, 'data-trial-monthly'),
          annual: centsOf(input, 'data-trial-annual'),
        });
      } else if (cadence === 'poa') {
        recurring.push({ kind: 'poa', label: label });
      } else if (cadence === 'year' || cadence === 'month') {
        recurring.push({
          kind: cadence,
          cents: centsOf(input, 'data-recurring-cents'),
          label: label,
        });
      } else {
        unit += centsOf(input, 'data-price-cents');
      }
    });

    let addonUnit = 0;
    root.querySelectorAll('[data-cf-addon-add][data-added="true"]').forEach(function (input) {
      addonUnit += centsOf(input, 'data-price-cents');
    });

    const ex = (unit + addonUnit) * qty;
    const rate = parseFloat(panel.dataset.vatRate || '20');
    const inc = Math.round(ex * (1 + (Number.isFinite(rate) ? rate : 20) / 100));
    const exNode = panel.querySelector('[data-cf-subtotal-ex]');
    const incNode = panel.querySelector('[data-cf-subtotal-inc]');
    const recNode = panel.querySelector('[data-cf-subtotal-recurring]');
    if (exNode) exNode.textContent = money(ex);
    if (incNode) incNode.textContent = money(inc) + ' inc VAT (' + (Number.isFinite(rate) ? rate : 20) + '%)';
    if (!recNode) return;
    recNode.replaceChildren();

    recurring.forEach(function (item) {
      if (item.kind === 'trial') {
        const left =
          '+ ' +
          pounds(item.monthly) +
          '/mth (' +
          pounds(item.annual) +
          ' P.A.) per unit, year 1, then £7.50/mth. WebAlarm setup included';
        const right =
          qty > 1
            ? '× ' + qty + ' = ' + pounds(item.monthly * qty) + '/mth (' + pounds(item.annual * qty) + ' P.A.)'
            : '';
        line(recNode, left, right);
      } else if (item.kind === 'poa') {
        line(recNode, '+ POA ' + item.label, '');
      } else {
        const suffix = item.kind === 'month' ? '/mo' : '/yr';
        const right = qty > 1 ? '× ' + qty + ' = ' + money(item.cents * qty) + suffix : '';
        line(recNode, '+ ' + money(item.cents) + suffix + ' ' + item.label, right);
      }
    });
  }

  function upfrontCents(input) {
    const cadence = input.dataset.cadence;
    if (cadence === 'year' || cadence === 'month') return centsOf(input, 'data-recurring-cents');
    if (cadence === 'trial') return centsOf(input, 'data-trial-annual');
    if (cadence === 'poa') return 0;
    return centsOf(input, 'data-price-cents');
  }

  function hardwareTitle(root) {
    const config = root.querySelector('[data-cf-hardware-title]');
    if (config && config.dataset.cfHardwareTitle) return config.dataset.cfHardwareTitle;
    const title = root.querySelector('.cf-title');
    return title ? title.textContent.trim() : '';
  }

  function extras(root, mainId, qty) {
    const items = [];
    const seen = {};
    const parent = hardwareTitle(root);
    function push(id) {
      if (!id || String(id) === String(mainId) || seen[id]) return;
      seen[id] = true;
      const item = { id: Number(id), quantity: qty };
      if (parent) item.properties = { _for: parent };
      items.push(item);
    }
    root.querySelectorAll('[data-cf-choice]:checked').forEach(function (input) {
      if (input.dataset.variantId) push(input.dataset.variantId);
    });
    root.querySelectorAll('[data-cf-addon-add][data-added="true"]').forEach(function (button) {
      if (button.dataset.variantId) push(button.dataset.variantId);
    });
    return items;
  }

  function showError(root, message) {
    const node = root.querySelector('[ref="addToCartTextError"]');
    if (!node) return;
    node.classList.remove('hidden');
    node.textContent = message;
  }

  function addBundle(root, form) {
    const routes = window.Theme && Theme.routes;
    const button = root.querySelector('[ref="addToCartButton"]');
    const mainId = variantId(root);
    const qty = quantityOf(root);
    const sim = root.querySelector('[data-cf-property="sim"]');
    const monitoring = root.querySelector('[data-cf-property="monitoring"]');
    const properties = {};
    if (sim && sim.value) properties['Connectivity (SIM)'] = sim.value;
    if (monitoring && monitoring.value) properties['WebAlarm Monitoring'] = monitoring.value;
    const items = [
      {
        id: Number(mainId),
        quantity: qty,
        properties: properties,
      },
    ].concat(extras(root, mainId, qty));
    const sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (item) {
      if (item.dataset.sectionId) sectionIds.push(item.dataset.sectionId);
    });

    let resolvePromise;
    let rejectPromise;
    const promise = new Promise(function (resolve, reject) {
      resolvePromise = resolve;
      rejectPromise = reject;
    });
    const update = new Event('shopify:cart:lines-update', { bubbles: true });
    update.action = 'add';
    update.lines = items.map(function (item) {
      return { merchandiseId: String(item.id), quantity: item.quantity };
    });
    update.promise = promise;
    document.dispatchEvent(update);

    if (button) button.disabled = true;
    const endpoint = (routes && routes.cart_add_url) || '/cart/add.js';
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionIds.join(',') }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (added) {
        if (added && added.status) {
          const message = added.description || added.message || 'Could not add to cart';
          showError(root, message);
          resolvePromise({
            cart: { totalQuantity: 0 },
            detail: { didError: true, items: [], sections: {} },
          });
          return;
        }
        const cartEndpoint = ((routes && routes.cart_url) || '/cart') + '.js';
        return fetch(cartEndpoint, { headers: { Accept: 'application/json' } })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            resolvePromise({
              cart: { totalQuantity: cart.item_count },
              detail: {
                items: cart.items,
                sections: (added && added.sections) || {},
                didError: false,
              },
            });
          });
      })
      .catch(function (error) {
        showError(root, 'Could not add to cart');
        rejectPromise(error);
      })
      .finally(function () {
        if (button) button.disabled = false;
        form.dataset.cfAdding = '';
      });
  }

  function placePopover(pop, anchor) {
    pop.hidden = false;
    pop.style.visibility = 'hidden';
    const margin = 8;
    const anchorRect = anchor.getBoundingClientRect();
    const width = pop.offsetWidth;
    const height = pop.offsetHeight;
    let top = anchorRect.bottom + margin;
    let left = anchorRect.left + anchorRect.width / 2 - width / 2;
    if (top + height > window.innerHeight - margin) {
      top = anchorRect.top - height - margin;
    }
    if (top < margin) top = margin;
    if (left < margin) left = margin;
    if (left + width > window.innerWidth - margin) {
      left = Math.max(margin, window.innerWidth - width - margin);
    }
    pop.style.top = top + 'px';
    pop.style.left = left + 'px';
    pop.style.visibility = '';
  }

  function closePopover(tile) {
    const button = tile.querySelector('.cf-addon__tile');
    const pop = tile.querySelector('.cf-addon__pop');
    if (!pop || pop.hidden) return;
    pop.hidden = true;
    if (button) button.setAttribute('aria-expanded', 'false');
  }

  function openPopover(tile) {
    const button = tile.querySelector('.cf-addon__tile');
    const pop = tile.querySelector('.cf-addon__pop');
    if (!button || !pop) return;
    const root = tile.closest('[data-cf-product]');
    if (root) {
      root.querySelectorAll('[data-cf-addon-tile]').forEach(function (other) {
        if (other !== tile) closePopover(other);
      });
    }
    placePopover(pop, button);
    button.setAttribute('aria-expanded', 'true');
  }

  function markAdded(button) {
    const tile = button.closest('[data-cf-addon-tile]');
    button.dataset.added = 'true';
    button.textContent = '✓';
    button.setAttribute('aria-label', (button.dataset.title || 'Add-on') + ' added');
    if (tile) {
      tile.classList.add('is-added');
      const tick = tile.querySelector('.cf-addon__tick');
      if (tick) tick.hidden = false;
    }
  }

  function clearAddon(button) {
    const tile = button.closest('[data-cf-addon-tile]');
    button.dataset.added = 'false';
    button.textContent = '+';
    button.setAttribute('aria-label', 'Add ' + (button.dataset.title || 'add-on'));
    if (tile) {
      tile.classList.remove('is-added');
      const tick = tile.querySelector('.cf-addon__tick');
      if (tick) tick.hidden = true;
    }
  }

  function toggleAddon(root, button) {
    if (!button || !button.dataset.variantId) return;
    if (button.dataset.added === 'true') {
      clearAddon(button);
    } else {
      markAdded(button);
    }
    refresh(root);
    const status = root.querySelector('[data-cf-addon-status]');
    if (!status) return;
    status.textContent =
      button.dataset.added === 'true' ? (button.dataset.title || 'Add-on') + ' included in this order' : '';
  }

  function bindAddons(root) {
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    root.querySelectorAll('[data-cf-addon-tile]').forEach(function (tile) {
      const opener = tile.querySelector('.cf-addon__tile');
      const pop = tile.querySelector('.cf-addon__pop');
      if (!opener || !pop) return;
      if (canHover) {
        let hoverTimer = 0;
        tile.addEventListener('mouseenter', function () {
          window.clearTimeout(hoverTimer);
          openPopover(tile);
        });
        tile.addEventListener('mouseleave', function () {
          window.clearTimeout(hoverTimer);
          hoverTimer = window.setTimeout(function () {
            if (pop.contains(document.activeElement)) return;
            closePopover(tile);
          }, 200);
        });
      }
      opener.addEventListener('click', function () {
        if (opener.getAttribute('aria-expanded') === 'true' && !canHover) {
          closePopover(tile);
        } else {
          openPopover(tile);
        }
      });
      opener.addEventListener('focus', function () {
        openPopover(tile);
      });
      pop.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closePopover(tile);
          opener.focus();
        }
      });
      const plus = pop.querySelector('[data-cf-addon-add]');
      if (plus) {
        plus.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          toggleAddon(root, plus);
        });
      }
    });
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      const open = root.querySelector('.cf-addon__tile[aria-expanded="true"]');
      if (!open) return;
      const tile = open.closest('[data-cf-addon-tile]');
      if (!tile) return;
      closePopover(tile);
      open.focus();
    });
    root.addEventListener('focusout', function (event) {
      const tile = event.target.closest && event.target.closest('[data-cf-addon-tile]');
      if (!tile) return;
      if (tile.contains(event.relatedTarget)) return;
      closePopover(tile);
    });
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-cf-addon-tile]')) return;
      root.querySelectorAll('[data-cf-addon-tile]').forEach(closePopover);
    });
    const scroller = document.querySelector('.page-wrapper') || window;
    scroller.addEventListener('scroll', function () {
      root.querySelectorAll('[data-cf-addon-tile]').forEach(function (tile) {
        const pop = tile.querySelector('.cf-addon__pop');
        const opener = tile.querySelector('.cf-addon__tile');
        if (pop && opener && !pop.hidden) placePopover(pop, opener);
      });
    }, { passive: true });
  }

  function bind(root) {
    if (!root || root.dataset.cfBuyBound === 'true') return;
    const hasChoices = !!root.querySelector('[data-cf-config]');
    if (!hasChoices && !root.querySelector('[data-cf-subtotal]')) return;
    root.dataset.cfBuyBound = 'true';
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const configToggle = root.querySelector('[data-cf-config-toggle]');
    const configPanel = root.querySelector('[data-cf-config-panel]');
    if (configToggle && configPanel) {
      configToggle.addEventListener('click', function () {
        const open = configToggle.getAttribute('aria-expanded') !== 'true';
        configToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        configPanel.hidden = !open;
      });
    }
    bindAddons(root);
    refresh(root);
    root.addEventListener('change', function () {
      refresh(root);
    });
    root.addEventListener('input', function (event) {
      if (event.target && event.target.name === 'quantity') refresh(root);
    });
    root.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('quantity-selector-component, .quantity-selector')) {
        requestAnimationFrame(function () {
          refresh(root);
        });
      }
    });
    root.addEventListener('cf:variant', function () {
      refresh(root);
    });
    if (!form || !hasChoices) return;
    function takeOver(event) {
      refresh(root);
      const more = extras(root, variantId(root), quantityOf(root));
      if (!more.length) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      if (form.dataset.cfAdding === 'true') return;
      form.dataset.cfAdding = 'true';
      addBundle(root, form);
    }
    form.addEventListener('submit', takeOver, true);
    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton) submitButton.addEventListener('click', takeOver, true);
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-cf-product]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
